module.exports = __webpack_public_path__ + "img/Daikin_Header.3b40d5f8.png";